import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SegnalazioniService {

  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  public getEventListByEnte(idEnte: number, page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.EventiSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('idEnte', `${idEnte}`);
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        if (key == "dataEventoDa" || key == "dataEventoA") {
          filters[key] = this.datePipe.transform(filters[key], "yyyy/MM/dd");
        }
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.EventoDto[]>(`${environment.urls.base}/evento/eventi-segnalazioni`,
        {
          params: searchParams
        });
  }

  public getSegnalazioniDaInviare(idEnte: number, page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.SegnalazioneDaInviareDTO) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('idEnte', `${idEnte}`);
    // searchParams = searchParams.append('idInvio', `${idInvio}`);
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        if (key == "dataEventoDa" || key == "dataEventoA") {
          filters[key] = this.datePipe.transform(filters[key], "yyyy/MM/dd");
        }
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.EventoDto[]>(`${environment.urls.base}/invii/list`,
        {
          params: searchParams
        });
  }
}
